import React from "react";
import { Link } from "./PageLink";
import logoSrc from "@assets/Logo_J&S_500_white_footer.png";
import MapEmbed from "./MapEmbed";
import { SocialLinks } from "./Header";

import { CLUSTERS, SERVICES } from "../lib/areas";

const Footer: React.FC = () => {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={logoSrc} alt="J&S Audio Video Solutions" width={500} height={373} decoding="async" loading="lazy" />
            <p>Central Massachusetts' most trusted audio & visual equipment supplier and installation pros.</p>
            <a href="tel:+15084500490" className="footer-phone" data-testid="link-footer-phone">508-450-0490</a>
            <div><span className="footer-phone">31 Crestwood Rd, Leicester, MA 01524</span></div>
            <div className="footer-hours">Sun – Sat, 9:00 AM – 6:00 PM</div>
            <SocialLinks variant="footer" />
          </div>

          <div>
            <h4>Services</h4>
            <ul className="footer-links">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={s.path} data-testid={`link-footer-service-${s.slug}`}>{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Service Areas</h4>
            <div className="footer-areas">
              {CLUSTERS.map((cluster) => (
                <div className="footer-area-block" key={cluster.slug}>
                  <h5>{cluster.name}</h5>
                  <ul>
                    {cluster.cities.map((city) => (
                      <li key={city}>
                        <Link
                          to={cluster.path}
                          data-testid={`link-footer-city-${cluster.slug}-${city.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                        >
                          {city.replace(/, MA$/, "")}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4>Company</h4>
            <ul className="footer-links">
              <li><Link to="/contact" data-testid="link-footer-contact">Contact</Link></li>
              <li><Link to="/privacy" rel="nofollow" data-testid="link-footer-privacy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        <MapEmbed />

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} J&amp;S Audio Video Solutions. All rights reserved.</p>
          <p className="footer-image-notice" data-testid="text-image-notice">All images on the site are property of J&amp;S Audio Video Solutions.</p>
          <p className="footer-image-notice">Website by <a className="footer-credit-link" href="https://morecommercialjobs.com" target="_blank" rel="noopener noreferrer">The Right Path Marketing</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
